import { useNavigate, useLocation } from 'react-router-dom';

// History-aware back for the detail surfaces (note-redesign PR2): in-app history → go back
// (which restores the map list's URL-encoded state); a cold deep-link → the named fallback.
//
// It returns the LABEL as well as the handler, and that is the whole point. The label used to be
// the hardcoded string "‹ Map" inside ConversationDetailSurface while the handler was navigate(-1),
// so a note opened from the brief, from Ask, from Actions, from standup or from Settings told the
// user the way back was the map. The behaviour was right and only the label lied — which is worse
// than it sounds, because a user who distrusts the button reaches for the top nav instead and
// loses their place entirely. Whatever decides the destination must also decide the label.

export interface DetailBack {
  go: () => void;
  label: string;
}

export function useDetailBack(fallbackPath = '/map?view=list', fallbackLabel = 'Map'): DetailBack {
  const navigate = useNavigate();
  const location = useLocation();
  // location.key is 'default' only on a cold load (a pasted link, a refresh) — i.e. there is no
  // in-app history entry to go back to.
  const cameFromInApp = location.key !== 'default';
  return {
    go: () => {
      if (cameFromInApp) navigate(-1);
      else navigate(fallbackPath);
    },
    label: cameFromInApp ? 'Back' : fallbackLabel,
  };
}
